import { auditReports } from '@mi-front/api-clients';
import { DateStr, today } from '@mi-front/core';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { LtxMatchesReportForm } from './form';
import { LtxMatchesReportResult } from './result';
import { LtxMatchesReport } from './types';
import { Station } from '@app/core/types/stations';

export function LtxMatchesReportView(p: { station: Station }) {
  const resetValues = {
    stationId: p.station.slug,
    date: today() as DateStr,
  };

  return (
    <ReportView<LtxMatchesReport>
      defaultValues={resetValues}
      reportFn={(values) => {
        return auditReports.executeLtxMatchesReport({
          stationId: p.station.slug,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={LtxMatchesReportForm}
      Result={LtxMatchesReportResult}
    />
  );
}
